import React, { useEffect, useState, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import Dropdown from '../Dropdown/Dropdown';
import styles from './FormTableDropdownControl.module.css';

function FormTableDropdownControl({ name, disabled = false, options = [], unit }) {
  const { register, setValue, formState } = useFormContext();
  const [selectedItem, setSelectedItem] = useState(null);

  const isDisabled = useMemo(() => disabled, [disabled]);

  useEffect(() => {
    if (formState.isSubmitSuccessful || !formState.isDirty) {
      setSelectedItem(null);
    }
  }, [formState.isSubmitSuccessful, formState.isDirty]);

  return (
    <div className={styles.dropdownContainer}>
        <Dropdown
            {...register(name)}
            className={classNames({
                [styles.disable]: isDisabled
            })}
            disabled={isDisabled}
            keyRef={true}
            showItems={Math.min(options.length, 8)}
            selectItem={(item) => {
                setValue(name, item, { shouldValidate: true, shouldDirty: true });
                setSelectedItem(item);
            }}
            title={selectedItem || 'Select'}
            data={options}
        />
        {unit ? <span className={styles.unit}>{unit}</span> : null}
    </div>
  );
}

export default FormTableDropdownControl;
